module.exports = __webpack_public_path__ + "static/img/introduce_img.5b01b14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce_img.jpg
// module id = BSOK
// module chunks = 1